import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import endpointList from "../../config/endpointList.jsx";

export const fetchElementsCategories = createAsyncThunk(
    'elementsCategories/fetchElementsCategories',
    async ({searchQuery=""}={}) => {
        const url = `${endpointList.getElementCategories}?elements=true&search=${searchQuery}`;
        const response = await fetch(url);
        const data = await response.json();
        return data;
    }
); 

export const fetchElements = createAsyncThunk(
    'elements/fetchElements',
    async ({ page, categoryId, search }) => {
      // Build URL with dynamic query parameters
      let url = `${endpointList.getElements}?page=${page}&category_id=${categoryId}`;
      if (search) {
        url += `&search=${encodeURIComponent(search)}`;
      }
      const response = await fetch(url);
      const data = await response.json();
      return {
        categoryId,
        elements: data.data, // elements array returned from the API
        currentPage: data.current_page,
        lastPage: data.last_page,
        nextPageUrl: data.next_page_url,
        prevPageUrl: data.prev_page_url,
        total: data.total,
      };
    }
  );

  const elementsSlice = createSlice({
    name: 'elements',
    initialState: {
        elements: [],
        status: 'idle',
        error: null,
        isLoaded: false,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchElementsCategories.pending, (state) => {
                state.status = 'loading';
                state.isLoaded = false;
            })
            .addCase(fetchElementsCategories.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.elements = action.payload.data;
                state.isLoaded = true;
            })
            .addCase(fetchElementsCategories.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
                state.isLoaded = false;
            })
            // Handle paginated/search fetch for elements
            .addCase(fetchElements.pending, (state) => {
                state.status = 'loading';
                state.isLoaded = false;
            })
            .addCase(fetchElements.fulfilled, (state, action) => {
                state.status = 'succeeded';
                const {
                    categoryId,
                    elements,
                    currentPage,
                    lastPage,
                    nextPageUrl,
                    prevPageUrl,
                    total,
                } = action.payload;
                // Look for the category in the state
                const existingCategory = state.elements.find(
                    (category) => category.id === categoryId
                );
                if (existingCategory) {
                    // Append new elements to the existing array
                    existingCategory.elements = existingCategory.elements.concat(elements);
                    existingCategory.currentPage = currentPage;
                    existingCategory.lastPage = lastPage;
                    existingCategory.nextPageUrl = nextPageUrl;
                    existingCategory.prevPageUrl = prevPageUrl;
                    existingCategory.total = total;
                } else {
                    // If not found, add a new category object with the pagination info and elements
                    state.elements.push({
                        id: categoryId,
                        elements,
                        currentPage,
                        lastPage,
                        nextPageUrl,
                        prevPageUrl,
                        total,
                    });
                }
                state.isLoaded = true;
            })
            .addCase(fetchElements.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.error.message;
                state.isLoaded = false;
            });
    },
});

export default elementsSlice.reducer;